import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { PulseLoader } from "react-spinners";
import { useOperator } from "../../utils/OperatorContext";
import CyberBoxComponent from "../shared/ui/layout/CyberBoxComponent";
import IndeviduealTableComponent from "./indeviduealTable/indeviduealTableComponent";

function AccountsComponent() {
  const { selectedDay } = useOperator();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setLoading(false), 600);
    return () => clearTimeout(t);
  }, [selectedDay]);

  return (
    <motion.div
      className="flex flex-col items-center justify-center overflow-hidden min-h-screen bg-background text-foreground p-6"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <motion.div
        className="p-6 rounded-2xl w-full "
        initial={{ scale: 0.98, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        {loading ? (
          <div className="flex items-center justify-center py-16">
            <PulseLoader />
          </div>
        ) : (
          <AnimatePresence mode="wait">
            <CyberBoxComponent>
              <IndeviduealTableComponent />
            </CyberBoxComponent>
          </AnimatePresence>
        )}
      </motion.div>
    </motion.div>
  );
}
export default AccountsComponent;
